export const EUROBEM_ADMIN_TEAMS = [
    { value: 'admin', label: 'Administrador' },
    { value: 'manager', label: 'Gerente' },
    { value: 'member', label: 'Membro' },
];

export function adminTeamLabel(value) {
    return EUROBEM_ADMIN_TEAMS.find(item => item.value === value)?.label || value || 'Sem cargo';
}
